<template>
    <BaseModal
        class="open-bills-for-table-modal"
        size="modal-lg"
        :closable="true"
        :hasHeader="false"
        :hasFooter="false"
        ref="baseModalComponent"
        @hide="onClosed"
    >
        <template v-slot:body>
            <div class="open-bills-for-table-container">
                <OpenBillsForTableList
                    :tableId="tableId"
                    :disableCurrentTable="false"
                    @openBillSelected="onOpenBillSelected"
                />
            </div>
        </template>
    </BaseModal>
</template>

<script setup lang="ts">
    import type { OpenBillSelectedEventData } from "@/data/model/Bill";
    import { ref } from "vue";

    import BaseModal from "@/components/dialog/BaseModal.vue";
    import OpenBillsForTableList from "@/operator/components/bill/OpenBillsForTableList.vue";

    defineProps<{
        tableId: string;
    }>();
    const emit = defineEmits(["openBillSelected", "closed"]);

    // define html refs
    const baseModalComponent = ref<InstanceType<typeof BaseModal> | null>(null);

    function onOpenBillSelected(openBill: OpenBillSelectedEventData) {
        emit("openBillSelected", openBill);
    }

    function onClosed() {
        emit("closed");
    }

    // define exposed
    function show() {
        baseModalComponent.value?.show();
    }

    function close() {
        baseModalComponent.value?.close();
    }

    defineExpose({
        show,
        close,
    });
</script>

<style lang="scss">
    @use "./../../../../assets/styles/scss/shared/_variables.scss";

    .modal.open-bills-for-table-modal {
        .modal-body {
            padding: 1.5em 2em;
        }

        .open-bills-for-table-container {
            margin-bottom: 1em;
        }
    }
</style>
